<div class="container text-center pt-4">
  <h1 [translate]="'pages.close'">The exercise is finished. You may close this window.</h1>
</div>

